import script from "./BindPhonePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BindPhonePage.vue?vue&type=script&setup=true&lang=js"

import "./BindPhonePage.vue?vue&type=style&index=0&id=4e06d60d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e06d60d"]])

export default __exports__